import type { SVGProps } from 'react';

// Wise logo from simple-icons - 24x24 viewBox
const Wise = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="#9FE870">
    <path d="M6.488 7.469 0 15.05h11.585l1.301-3.576H7.922l3.033-3.507.01-.092L8.993 4.48h8.873l-6.878 18.925h4.706L24 .595H2.543l3.945 6.874Z" />
  </svg>
);

// Alias for backward compatibility
const WiseBrand = Wise;

export { WiseBrand };
